import { Component, OnInit } from '@angular/core';
import { OnboardingService } from '../../services/onboarding.service';
import { BuildInfo } from '../../../clients/clients';

interface TestForm {
  id: number;
  name: string;
  email: string;
  age: number;
}

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  standalone: false,
})
export class AboutComponent implements OnInit {
  public serverBuildInfo: BuildInfo | undefined;
  public clientBuildInfo: BuildInfo | undefined;
  // public submissionClient: SubmissionForm | undefined;

  public user: TestForm = {
    id: 1234,
    name: '',
    email: '',
    age: 0
  };

  constructor(private service: OnboardingService) {
  }

  async ngOnInit(): Promise<void> {
    this.clientBuildInfo = this.service.getClientBuildInfo();
    this.serverBuildInfo = await this.service.getServerBuildInfo();
  }

  async handleSubmit(): Promise<void> {
    // const successOrFailure = await this.service.postSubmitForm(this.user);
    // if (successOrFailure.result) {
    //     console.log('worked', successOrFailure.result);
    // } else if (successOrFailure.error) {
    //     console.error('error', successOrFailure.error.errors);
    // }
  }
}
